import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import holidays from './modules/holidays';
import services from './modules/services';
import media from './modules/media';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isAuth: false,
        updating: false,
        userInfo: Object,
        loading: false,
        successful: false,
        isAccessable: false,
        isAccessableDev: false,
        defaultMenu: 'site',
    },
    mutations: {
        logined(state, value) {
            state.isAuth = value
        },
        updating(state, value) {
            state.updating = value
        },
        userInfo(state, value) {
            state.userInfo = value
        },
        loading(state, value) {
            state.loading = value
        },
        successful(state, value) {
            state.successful = value
        },
        isAccessable(state, value) {
            state.isAccessable = value
        },
        isAccessableDev(state, value) {
            state.isAccessableDev = value
        },
        defaultMenu(state, value) {
            state.defaultMenu = value
        }
    },
    actions: {
        logined: function(context, value) {
            context.commit("logined", value)
        },
        updating: function(context, value) {
            context.commit("updating", value)
        },
        userInfo: function(context, value) {
            context.commit("userInfo", value)
        },
        loading: function(context, value) {
            context.commit("loading", value)
        },
        successful: function(context, value) {
            context.commit("successful", value)
        },
        isAccessable: function(context, value) {
            context.commit("isAccessable", value)
        },
        isAccessableDev: function(context, value) {
            context.commit("isAccessableDev", value)
        },
        defaultMenu: function(context, value) {
            context.commit("defaultMenu", value)
        },
    },
    getters: {
    },
    modules: {
        services,
        holidays,
        media,
    },
    plugins: [
        createPersistedState({
            key: 'pochi-store',
            paths: [
                'isAuth',
                'userInfo',
                'isAccessable',
                'isAccessableDev',
                'defaultMenu',
            ],
        }),
    ],
})
